import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://jkuthtfxrplfhcqoyfsa.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImprdXRodGZ4cnBsZmhjcW95ZnNhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTkwNzEzNTIsImV4cCI6MjA3NDY0NzM1Mn0.VUzo_XCINAvwHYVFpxfBzHQasaOmJ6r_40GGpxNSqvc'

if(SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

export default supabase